import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useScopeStore = defineStore('scope', () => {
  const scope = ref({
    kind: null,
    accounts: [],
    active: [],
  })

  const hydrate = {
    /**
     * Replace the current scope.
     *
     * @param {{ kind: string | null, accounts: string[], active: string[] }} data
     */
    scope(data) {
      scope.value = data
    },

    /**
     * Replace the accounts available in the current scope.
     *
     * @param {string[]} accounts
     */
    accounts(accounts) {
      scope.value = { ...scope.value, accounts }
    },

    /**
     * Replace the active account filter within the current scope.
     *
     * @param {string[]} active
     */
    active(active) {
      scope.value = { ...scope.value, active }
    },
  }

  /** Clear scope on logout — no session, no kind. */
  function reset() {
    scope.value = {
      kind: null,
      accounts: [],
      active: [],
    }
  }

  return {
    scope,
    hydrate,
    reset,
  }
})
